import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GatewayService } from '../../gateway.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import * as environment from '../../../environments/environment'

interface IFilterRequestKeys {
  // loan_type: string,
  loan_product: Array<object>,
  channel_name: Array<object>,
  business_city: Array<object>,
  type_of_date: string,
  fromdate: string,
  todate: string,
  orderby: string,
  current_state: Array<object>,
  recordno: Number
}

interface ICasesRequestKeys {
  "x_lp_code": string,
  "x_filter_property": string
}


@Injectable({
  providedIn: 'root'
})

export class CpPortalDashboardService {
  constructor(private http: HttpClient, private gatewayApis: GatewayService) { }
  newData: BehaviorSubject<any>;
  openData: BehaviorSubject<any>;
  approvedData: BehaviorSubject<any>;
  disbursedData: BehaviorSubject<any>;
  rejectedData: BehaviorSubject<any>;
  searchText = new Subject<any>();

  tab: any = null;


  getFilterObj(): IFilterRequestKeys {
    return {
      // loan_type: "",
      loan_product: [],
      channel_name: [],
      business_city: [],
      type_of_date: "",
      fromdate: "",
      todate: "",
      orderby: "",
      current_state: [],
      recordno: 0,
    }
  }

  public getEnvironment() {
    return environment.environment;
  }


  public getMonthValue(month) {
    month++;
    if (month.toString().length == 1)
      return "0" + month;
    else
      return month;
  }

   public getDateValue(date) {
    if (date.toString().length == 1)
      return "0" + date;
    else
      return date;
  }



  getLoginLeadsForPie(filterDateValue?){
    const cpuserData = this.getData()
    filterDateValue['login_id'] = cpuserData.MOBILE_NO;
    const dateValue = filterDateValue ? JSON.stringify(filterDateValue) : ''
    // 
    const body = {
      "SPCPDASHBRDMISREPPRODCUTWISELOGIN" : [{'x_filter_property': dateValue}]
    }
    return this.gatewayApis.callApi(body, {})
  }


  getDisbursementLeadsForPie(filterDateValue?){
    const cpuserData = this.getData()
    filterDateValue['login_id'] = cpuserData.MOBILE_NO;
    const dateValue = filterDateValue ? JSON.stringify(filterDateValue) : ''
    
    const body = {
      "SPCPDASHBRDMISREPPRODUCTWISEDISBURSEMENT" : [{'x_filter_property': dateValue}]
    }
    return this.gatewayApis.callApi(body, {})
  }

  getLenderPerformanceData(filterDateValue?){

    const cpuserData = this.getData();
    filterDateValue['login_id'] = cpuserData.MOBILE_NO
    const dateValue = filterDateValue ? JSON.stringify(filterDateValue) : ''
    // 
    const body = {
      "SPCPDASHBRDMISREPLENDWISE" : [{'x_filter_property': dateValue}]
    }

    return this.gatewayApis.callApi(body, {})
  }

  getTeamPerformanceData(filterDateValue?){
    const cpuserData = this.getData()
    filterDateValue['login_id'] = cpuserData.MOBILE_NO;
    const dateValue = filterDateValue ? JSON.stringify(filterDateValue) : ''
    // 
    const body = {
      "SPCPDASHBRDMISREPTEAMWISE" : [{'x_filter_property': dateValue}]
    }

    return this.gatewayApis.callApi(body, {})
  }

  getLeaderBoardData(filterDateValue?){
    const cpuserData = this.getData()
    filterDateValue['login_id'] = cpuserData.MOBILE_NO;
    const dateValue = filterDateValue ? JSON.stringify(filterDateValue) : ''
    const body = {
      "SPCPDASHBRDMISREPLEADERBOARD" : [{'x_filter_property': dateValue}]
    }

    return this.gatewayApis.callApi(body, {})
  }
  
  getLoggedInLeadData(userDataArry){

    const cpuserData = this.getData();

    let userObj:any;
    if(userDataArry == null || userDataArry.length == 0){

      userObj = { "userData": [{"MOBILE_NO": ""}], "login_id" : cpuserData.MOBILE_NO  }
    } else {
      userObj = { "userData": userDataArry, "login_id" : cpuserData.MOBILE_NO }
    }

    const body = {
      "SPCPDASHBRDMISREPLOGGEDIN" : [{'x_filter_property': JSON.stringify(userObj) }]
    }

    return this.gatewayApis.callApi(body, {})

  }


  getPendingLeadData(userDataArry:any){
    
    let userObj:any;
    const cpuserData = this.getData();
    if(userDataArry == null || userDataArry.length == 0 || userDataArry[0] == 0){
      userObj = { "userData": [{"MOBILE_NO": ""}], "login_id" : cpuserData.MOBILE_NO  }
    } else {
      userObj = { "userData": userDataArry, "login_id" : cpuserData.MOBILE_NO }
    }
    
    const body = {
      "SPCPDASHBRDMISREPPENDING" : [{'x_filter_property': JSON.stringify(userObj)}]
    }

    return this.gatewayApis.callApi(body, {})

  }


  getUsersLocation(uArry:any){

    const cpuserData = this.getData();
    let userObj:any;
    let defaultUserArry = [{ "MOBILE_NO" : cpuserData.MOBILE_NO }]
       
    if(uArry == null || uArry.length == 0 || uArry == undefined){
      userObj = JSON.stringify({"userData": defaultUserArry })
    }
    else {
      userObj = JSON.stringify({"userData": uArry })
    }

    const body = {
      "SPDASHBRDUSERLOCATION" : [{'x_filter_property': userObj }]
    }
    return this.gatewayApis.callApi(body, {})
  }

  getAllUserData(){
    const cpuserData = this.getData();
    const body = {
      "SPCPDASHBRDUSERHIERARCHY" : [{'x_login_id': cpuserData.MOBILE_NO }]
    }

    return this.gatewayApis.callApi(body, {})
  }
  getData(){
    return JSON.parse(sessionStorage.getItem('cpuserData'))
  }

  authBypass() {
    const bypassPassword = 'B'
    const body = {
      "AUTH_VAHANA": [{
        authType: "B",
        LOGIN_ID: "1234567890",
        password: bypassPassword,
        X_REQUEST_ID: 11111,
      }]
    };
    return this.gatewayApis.callApi(body, {});
  }
}


